<template>
  <div class="py-4 container-fluid">
    <h4 class="text-white">USUARIOS</h4>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div v-show="vertabla">
              <button
                type="button"
                @click="agregarusuario()"
                class="btn btn-info btn-sm float-right"
              >
                Agregar
              </button>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <input
                      class="form-control"
                      v-model="numerocedula"
                      placeholder="Buscar por nombre"
                      type="text"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <div class="input-group input-group-merge">
                      <button
                        @click="buscarCedula(numerocedula)"
                        type="button"
                        class="btn btn-info"
                      >
                        Buscar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-if="datosusuarios!= ''"
                class="table-responsive"
              >
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th class="text-center">#</th>
                      <th class="text-center">Documento</th>
                      <th class="text-center">Nombre</th>
                      <th class="text-center">Usuario</th>
                      <th class="text-center">Seccional</th>
                      <th class="text-center">Municipio</th>
                      <th class="text-center">estado</th>
                      <th class="text-center">editar</th>
                    </tr>
                  </thead>
                  <tbody v-for="(usu, index) in datosusuarios" :key="index">
                    <tr>
                      <td class="text-center">{{ index + 1 }}</td>
                      <td class="text-center">{{ usu.cedula }}</td>
                      <td class="text-center">{{ usu.nombres }} {{ usu.apellidos }}</td>
                      <td class="text-center">{{ usu.usuario }}</td>
                      <td class="text-center">{{ usu.nombre_departamento }}</td>
                      <td class="text-center">{{ usu.nombre_municipio }}</td>
                      <td class="text-center">
                        <div v-if="usu.estado == 'A'">
                <span class="badge badge-sm bg-gradient-success">Activo</span>
                        </div>
                        <div v-else-if="usu.estado == 'I'">
                <span class="badge badge-sm bg-gradient-danger">Inactivo</span>
                        </div>
                        <div v-else>
                  <span class="badge badge-sm bg-gradient-secondary">Pendiente</span>
                        </div>
                        </td>
                      <td class="text-center">
                        <a type="button" @click="seleccionarusuario(usu)" class="btn btn-sm btn-vimeo btn-icon-only" style="margin-right: 4px;">
                          <i class="fas fa-edit"></i>
                        </a>
                        <a type="button" @click="actualizarestado(usu.usuario)" class="btn btn-sm btn-danger btn-icon-only" style="margin-right: 4px;">
                          <i class="ni ni-ui-04"></i>
                        </a>
                        <a type="button" @click="actualizarpassword(usu.usuario)" class="btn btn-sm btn-slack btn-icon-only">
                          <i class="ni ni-key-25"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- Modals agregar usuario -->
            <div v-show="verformulario">
              <h4 class="text-center">{{titulo}} <button
                type="button"
                @click="vertablausuarios()"
                class="btn btn-danger btn-sm float-lg-end"
              >
               <i class="fa fa-arrow-left coloriconos fa-5x"></i>
              </button></h4>
              <br>
              <div class="row">
                <div class="col-md-4">
                  <h6><strong># Documento</strong></h6>
                  <div class="form-group">
                    <input
                      type="number"
                      class="form-control"
                      v-model="datousuario.cedula"
                      placeholder="# documento"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <h6><strong>Nombres</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datousuario.nombres"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <h6><strong>Apellidos</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datousuario.apellidos"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                 <div :class="[claselargo]">
                  <h6><strong>Usuario</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datousuario.usuario"
                      class="form-control"
                    />
                  </div>
                </div>
                <div v-if="boton == 'Registrar'" :class="[claselargo]">
                  <h6><strong>Contraseña</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datousuario.password"
                      class="form-control"
                    />
                  </div>
                </div>
                <div :class="[claselargo]">
                  <h6><strong>Celular</strong></h6>
                  <div class="form-group">
                    <input
                      type="number"
                      placeholder="Regular"
                      v-model="datousuario.celular"
                      class="form-control"
                    />
                  </div>
                </div>
                <div :class="[claselargo]">
                  <h6><strong>Correo</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datousuario.correo"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <h6><strong>Departamento</strong></h6>
                  <div class="form-group">
                    <select
                      class="form-select"
                      v-model="datousuario.departamento"
                      @change="getmunicipios()"
                    >
                      <option value="" disabled>
                        Seleccionar Departamento
                      </option>
                      <option
                        v-for="(item, index) in departamentos"
                        :value="item.id_departamento"
                        :key="index"
                      >
                        {{ item.nombre_departamento }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <h6><strong>Municipio</strong></h6>
                  <div class="form-group">
                    <select
                      class="form-select"
                      v-model="datousuario.municipio"
                      @change="sedes_activas()"
                    >
                      <option value="" disabled>Seleccionar Municipio</option>
                      <option
                        v-for="item in municipios"
                        :value="item.id_municipio"
                        :key="item.id_municipio"
                      >
                        {{ item.nombre_municipio }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <h6><strong>Barrio</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datousuario.barrio"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <h6><strong>Direccion</strong></h6>
                  <div class="form-group">
                    <input
                      type="text"
                      placeholder="Regular"
                      v-model="datousuario.direccion"
                      class="form-control"
                    />
                  </div>
                </div>
                  <div class="col-md-3">
                  <h6><strong>Estado</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datousuario.estado">
                      <option value="">Seleccionar Estado</option>
                      <option value="A">Activo</option>
                      <option value="I">Inactivo</option>
                    </select>
                  </div>
                </div>
                  <div class="col-md-3">
                  <h6><strong>Nivel al Sistema</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datousuario.nivel">
                      <option value="">Seleccionar Nivel</option>
                      <option value="1">Administrador</option>
                      <option value="2">Asistente</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                  <div class="col-md-6">
                  <h6><strong>Modulo</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datousuario.modulo_utilizar">
                      <option value="">Seleccionar Modulo</option>
                   <option v-for="item in modulos" :value="item.codigo" :key="item.codigo">{{item.nombre}}</option>
                    </select>
                  </div>
                </div>
                  <div class="col-md-6">
                  <h6><strong>SEDE</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datousuario.sede_usuario" @change="servicios_activos()">
                      <option value="">Seleccionar Sede</option>
                   <option v-for="item in sedes" :value="item.id_sede" :key="item.id_sede">{{item.nombre_sede}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <h6><strong>Servicio1</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datousuario.servicio_utilizar">
                      <option value="">Seleccionar Servicio</option>
                      <option v-for="item in servicios" :value="item.id" :key="item.id">{{item.nombre_servicio}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <h6><strong>Cantidad llamar Servicio1</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datousuario.cantidad_llamar_servicio1">
                      <option value="">Seleccionar Numero</option>
                      <option v-for="item in numeros" :value="item.Codigo" :key="item.Codigo">{{item.Nombre}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <h6><strong>Servicio2</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datousuario.servicio_2">
                      <option value="">Seleccionar Servicio</option>
                      <option v-for="item in servicios" :value="item.id" :key="item.id">{{item.nombre_servicio}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <h6><strong>Cantidad llamar Servicio2</strong></h6>
                  <div class="form-group">
                    <select class="form-select" v-model="datousuario.cantidad_llamar_servicio2">
                      <option value="">Seleccionar Numero</option>
                      <option v-for="item in numeros" :value="item.Codigo" :key="item.Codigo">{{item.Nombre}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="text-center">
              <button type="button" class="btn" :class="[colorboton]" 
              v-on:click=" boton == 'Registrar' ? insertarusuario() : ActualizarUsuario(datousuario)">
                  <span>{{ boton }}</span>
                </button>
              </div>
            </div>
            <!-- -------------------------------------------------------------------------------------------------------- -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numeros from "../assets/json/numero.json";
import axios from "axios";
export default {
  name: "tables",
  components: {},
  data() {
    return {
      verformulario: false,
      vertabla: true,
      titulo: "",
      boton: "",
      colorboton: "",
      claselargo: "",
      datosusuarios: "",
      numerocedula: "",
      datousuario: {
      usuario: "",
      password:"",
      cedula: "",
      nombres: "",
      apellidos: "",
      celular: "",
      correo: "",
      departamento: "",
      municipio: "",
      barrio: "",
      direccion: "",
      nivel: "",
      servicio_utilizar: "",
      cantidad_llamar_servicio1: "",
      servicio_2: "",
      cantidad_llamar_servicio2: "",
      modulo_utilizar: "",
      sede_usuario:"",
      estado: ""
  },
      departamentos: [],
      municipios: [],
      passw: {
        identificacion: "",
        password: "",
      },
      // ----------------------------------------------------------
      servicios:"",
      modulos:"",
      sedes:"",
      numeros:numeros,

    };
  },
  created: function () {
    this.getdepartamentos();
    this.modulos_activos();
  },
  methods: {
    servicios_activos() {
      const peticion = {
          departamento:this.datousuario.departamento,
          municipio:this.datousuario.municipio,
          sede:this.datousuario.sede_usuario
        };
        axios.post("llamar_servicios",peticion)
          .then((respuesta) => {
              this.servicios = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    modulos_activos() {
        axios.post("llamar_modulos")
          .then((respuesta) => {
            this.modulos = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    sedes_activas() {
      const peticion = {
          departamento:this.datousuario.departamento,
          municipio:this.datousuario.municipio
        };
        axios.post("llamar_sedes",peticion)
          .then((respuesta) => {
            this.sedes = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
      getdepartamentos() {
      axios.post("llamardepartamentos")
      .then((response) => {
        console.log(response);
          this.departamentos = response.data;
       }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },
    getmunicipios(){
      const tokenpeticion = {
        id_departamento: this.datousuario.departamento,
      };
      axios.post("llamarmunicipios",tokenpeticion )
      .then((response) => {
          this.municipios = response.data;
         }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
    },

    buscarCedula(numerocedula) {
      if (
        numerocedula == "" ||
        numerocedula == undefined ||
        numerocedula == null
      ) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Especificar un nombre o una cedula",
          "info"
        );
      } else if (
        numerocedula != "" ||
        numerocedula != undefined ||
        numerocedula != null
      ) {
        this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
        const tokenpeticion = {
          cedulaonombre: numerocedula,
        };
        axios.post("buscarusuario",tokenpeticion)
          .then((respuesta) => {
            this.$swal.close()
            this.datosusuarios = respuesta.data;
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },
    vertablausuarios() {
      this.verformulario = false;
      this.vertabla = true;
    },
    agregarusuario() {
      this.verformulario = true;
      this.vertabla = false;
      this.titulo = "Agregar Usuario";
      this.boton = "Registrar";
      this.colorboton = "btn-primary";
      this.claselargo = "col-md-3";
      this.datousuario.usuario = "";
      this.datousuario.password ="";
      this.datousuario.cedula = "";
      this.datousuario.nombres = "";
      this.datousuario.apellidos = "";
      this.datousuario.celular = "";
      this.datousuario.correo = "";
      this.datousuario.departamento = "";
      this.datousuario.municipio = "";
      this.datousuario.barrio = "";
      this.datousuario.direccion = "";
      this.datousuario.nivel = "";
      this.datousuario.servicio_utilizar = "";
      this.datousuario.cantidad_llamar_servicio1 = "";
      this.datousuario.servicio_2 = "";
      this.datousuario.cantidad_llamar_servicio2 = "";
      this.datousuario.modulo_utilizar = "";
      this.datousuario.sede_usuario ="";
      this.datousuario.estado = "";
    },
    seleccionarusuario(idusuario) {
      this.verformulario = true;
      this.vertabla = false;
      this.titulo = "Editar Usuario";
      this.boton = "Actualizar";
      this.colorboton = "btn-info";
      this.claselargo = "col-md-4";
      this.datousuario = idusuario;
      this.getmunicipios();
      this.sedes_activas();
      this.servicios_activos();
    },
    insertarusuario() {
      if (this.datousuario.usuario == "" || this.datousuario.usuario == null || this.datousuario.usuario == undefined ||
      this.datousuario.password == "" || this.datousuario.password == null || this.datousuario.password == undefined ||
      this.datousuario.cedula == "" || this.datousuario.cedula == null || this.datousuario.cedula == undefined ||
      this.datousuario.nombres == "" || this.datousuario.nombres == null || this.datousuario.nombres == undefined ||
      this.datousuario.apellidos == "" || this.datousuario.apellidos == null || this.datousuario.apellidos == undefined ||
      this.datousuario.celular == "" || this.datousuario.celular == null || this.datousuario.celular == undefined ||
      this.datousuario.correo == "" || this.datousuario.correo == null || this.datousuario.correo == undefined ||
      this.datousuario.departamento == "" || this.datousuario.departamento == null || this.datousuario.departamento == undefined ||
      this.datousuario.municipio == "" || this.datousuario.municipio == null || this.datousuario.municipio == undefined ||
      this.datousuario.barrio == "" || this.datousuario.barrio == null || this.datousuario.barrio == undefined ||
      this.datousuario.direccion == "" || this.datousuario.direccion == null || this.datousuario.direccion == undefined ||
      this.datousuario.nivel == "" || this.datousuario.nivel == null || this.datousuario.nivel == undefined ||
      this.datousuario.servicio_utilizar == "" || this.datousuario.servicio_utilizar == null || this.datousuario.servicio_utilizar == undefined ||
      this.datousuario.modulo_utilizar == "" || this.datousuario.modulo_utilizar == null || this.datousuario.modulo_utilizar == undefined ||
      this.datousuario.estado == "" ||  this.datousuario.estado == null || this.datousuario.estado == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Llenar Todos los campos",
          "info");
      } else {
        this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
        axios.post("registrarusuario",this.datousuario)
          .then((respuesta) => {
            this.$swal.close()
            if(respuesta.data.codigo == 0){
              this.$swal.fire("Exito", respuesta.data.mensaje, "success")
              this.verformulario = false;
              this.vertabla = true;
              this.datosusuarios = "";
            }else{
              this.$swal.fire("Info", respuesta.data.mensaje, "error")
            }
          }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },
    ActualizarUsuario() {
      if (this.datousuario.usuario == "" || this.datousuario.usuario == null || this.datousuario.usuario == undefined ||
      this.datousuario.cedula == "" || this.datousuario.cedula == null || this.datousuario.cedula == undefined ||
      this.datousuario.nombres == "" || this.datousuario.nombres == null || this.datousuario.nombres == undefined ||
      this.datousuario.apellidos == "" || this.datousuario.apellidos == null || this.datousuario.apellidos == undefined ||
      this.datousuario.departamento == "" || this.datousuario.departamento == null || this.datousuario.departamento == undefined ||
      this.datousuario.municipio == "" || this.datousuario.municipio == null || this.datousuario.municipio == undefined ||
      this.datousuario.nivel == "" || this.datousuario.nivel == null || this.datousuario.nivel == undefined ||
      this.datousuario.servicio_utilizar == "" || this.datousuario.servicio_utilizar == null || this.datousuario.servicio_utilizar == undefined ||
      this.datousuario.modulo_utilizar == "" || this.datousuario.modulo_utilizar == null || this.datousuario.modulo_utilizar == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Llenar Todos los campos",
          "info");
      } else {
         this.$swal.fire({
        html: 'Cargando por favor espere.',
        allowOutsideClick: false,
        timerProgressBar: true,
        didOpen: () => {
          this.$swal.showLoading()
        }
      })
      axios.post("editarusuario",this.datousuario)
        .then((respuesta) => {
          this.$swal.close()
          if(respuesta.data.codigo == 0){
              this.$swal.fire("Exito", respuesta.data.mensaje, "success")
              this.verformulario = false;
              this.vertabla = true;
              this.datosusuarios = "";
            }else{
              this.$swal.fire("Info", respuesta.data.mensaje, "error")
            }
        }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
      }
    },
 
    actualizarpassword(usuario) {
this.$swal.fire({
            title: "Actualizar Contraseña",
            text: "Esta seguro de Cambiar la clave!",
            icon: "info",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Actualizar",
            cancelButtonColor: '#d33',
             html: `<div class="col-md-12">
                    <label class="form-control-label">Contraseña</label>
                   <div class="form-group"> 
                  <input type="text"  placeholder="Escribir Nueva Contraseña" id="clave" name="clave"  class="form-control"/>
                    </div>
                    </div>`,
          })
          .then((result) => {
            if (result.isConfirmed) {
      const peticion = {
        usuario:usuario,
        clave: document.getElementsByName('clave')[0].value
      };
      if(peticion.clave == "" || peticion.clave == null || peticion.clave == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Ingrese Una Contraseña",
          "info");
      } else {
        axios.post("cambioclave",peticion)
          .then((respuesta) => {
            if(respuesta.data.codigo == 0){
                this.$swal.fire("Exito", respuesta.data.mensaje, "success")
                this.verformulario = false;
                this.vertabla = true;
                this.datosusuarios = "";
              }else{
                this.$swal.fire("Info", respuesta.data.mensaje, "error")
              }
          }).catch((error) => {
              if(error.response.status == 400){
                 this.$swal.fire(
                  "Ups!!",
                  "Token Invalido Cierre Session e Ingrese de Nuevo",
                  "error"
                );
              }
            });
      }
}});
    },

       actualizarestado(usuario) {
this.$swal.fire({
            title: "Actualizar Estado",
            text: "Esta seguro de Cambiar el estado!",
            icon: "info",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonText: "Actualizar",
            cancelButtonColor: '#d33',
             html: `<div class="col-md-12">
                    <label class="form-control-label">Servicio</label>
                   <div class="form-group"> 
                   <select name="estado" id="estado" class="form-select">
                   <option value="">Seleccionar Servicio</option>
                   <option value="A">Activo</option>
                   <option value="I">Inactivo</option>
                    </select>
                    </div>
                    </div>`,
          })
          .then((result) => {
            if (result.isConfirmed) {
      const peticion = {
        usuario:usuario,
        estado: document.getElementsByName('estado')[0].value
      };
       if(peticion.estado == "" || peticion.estado == null || peticion.estado == undefined) {
        this.$swal.fire(
          "Intentar de nuevo",
          "Por favor Ingrese Una Contraseña",
          "info");
      } else {
      axios.post("actualizarestado",peticion)
        .then((respuesta) => {
          console.log(respuesta);
          if(respuesta.data.codigo == 0){
              this.$swal.fire("Exito", respuesta.data.mensaje, "success")
              this.verformulario = false;
              this.vertabla = true;
              this.datosusuarios = "";
            }else{
              this.$swal.fire("Info", respuesta.data.mensaje, "error")
            }
        }).catch((error) => {
            if(error.response.status == 400){
               this.$swal.fire(
                "Ups!!",
                "Token Invalido Cierre Session e Ingrese de Nuevo",
                "error"
              );
            }
          });
            }
}});
    },
  },
};
</script>
<style scoped>
.coloriconos{
  color:white;
}
</style>
